import { ReferralCodeError } from './referral-code-types';
import { ErrorMessages } from '../../../model/error';
import commonErrorMessages from '../../../messages/common-messages/common-error.messages';
import referralCodeMessages from '../../../messages/onboarding-self/referral-code.messages';
import { ReferralCodeRequestParams } from './referral-code-types';

export const verifyReferralCodeFields = (
  formValues: ReferralCodeRequestParams
): ReferralCodeError | undefined => {
  const { referralCode } = formValues;

  if (!referralCode) {
    return 'FILL_ALL_FIELDS';
  }
  return undefined;
};

export const messagesForReferralCodeError = (
  error: ReferralCodeError
): ErrorMessages => {
  switch (error) {
    case 'GENERIC_ERROR':
      return {
        title: commonErrorMessages.errorTitleDefault,
        description: commonErrorMessages.errorDescriptionDefault,
      };
    case 'INVALID_REFERRAL_CODE':
      return {
        title: referralCodeMessages.errorInvalidReferralCode,
      };
    case 'FILL_ALL_FIELDS':
      return {
        title: referralCodeMessages.errorEmptyReferralCode,
      };
  }
  return undefined;
};
